const multicolumnSwiperNew = new Swiper(".multicolumn-swiper .swiper", {
    navigation: {
      nextEl: ".multicolumn-swiper .swiper-button-next",
      prevEl: ".multicolumn-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".multicolumn-swiper .swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: false, 
    loop: false, 
    breakpoints: {
      750: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween:0
      },
    },
});